/* eslint-disable */
export default {
  unmute: 'Poista mykistys',
  mute: 'Mykistä',
  keypad: 'Näppäimistö',
  hold: 'Pito',
  onHold: 'Pidossa',
  park: 'Säilytyksessä',
  stopRecord: 'Lopeta',
  record: 'Tallenna',
  add: 'Lisää',
  transfer: 'Siirrä',
  flip: 'Käännä',
  more: 'Puhelutoiminnot',
  mergeToConference: 'Yhdistä',
  end: 'Lopeta',
  completeTransfer: 'Suorita\nsiirto',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
